import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchCustomer, updateCustomer, updateOrdersEditCustomer } from "../../store/register/customerAction";
import { fetchTitles, fetchAddressProject, fetchAddressCompany } from "../../store/query/queryAction";
import { msg, config } from "../../constants"
import RegisterHeader from "./RegisterHeader"
import RegisterForm from "./RegisterForm"
import RegisterModal from "./RegisterModal"
import { Modal, ModalBody, Spinner } from 'reactstrap';

import axios from 'axios';

class registerPage extends Component {
  state = {
    mode: "", // View, Edit, Expire
    modalSubmit: false,
    modalOrder: false,
    message: "",
    submit: false,
    isFirstTime: true,
    modalIsOpen: false
  };


  async componentDidMount() {

    let resp = await axios.post(config.apiUrl + "/login/gtkn", {});

    // if (parseInt(resp.data.code) === 200) {
    //   localStorage.setItem('sys_token', resp.data.token);
    // }
    
    const { project, customerID } = this.props;
    const params = { project_id: project.project_id, customer_id: customerID };
    this.props.fetchCustomer(params);
    this.props.fetchTitles();
    this.props.fetchAddressProject(params);
    this.props.fetchAddressCompany(params);
  }

  componentWillReceiveProps(nextProps) {
    const { customer, project } = nextProps;
    if (customer && this.state.isFirstTime) {
      let mode = "Expire";
      if (project.project_status === "A" && project.order_status === 'A') {
        mode = customer.id_card ? "View" : "Edit";
      }
      this.setState({
        mode: mode,
        isFirstTime: false
      })
    }
  }

  openModal = () => {
    this.setState({ modalIsOpen: true });
  }
  closeModal = () => {
    this.setState({ modalIsOpen: false });
  }

  handleEdit = mode => {
    if (this.props.orders.length > 0) {
      this.showOrderModal();
    } else {
      this.enableEdit(mode);
    }
  };

  enableEdit = (mode) => {
    this.setState({
      mode: mode,
    });
  }

  checkMode = () => {
    return this.state.mode === "Edit" ? false : true
  };

  showOrderModal = () => {
    this.setState({
      modalOrder: true,
    });
  }

  showSubmitModal = (message, success) => {
    this.setState({
      modalSubmit: true,
      message: message,
      submit: success,
    });
  }

  handleOrderModal = (visible, mode) => {
    this.setState({
      modalOrder: visible,
      mode: mode
    });
    if (mode === 'Edit') {
      const { project, customerID } = this.props;
      const params = { project_id: project.project_id, customer_id: customerID };
      this.props.updateOrdersEditCustomer(params);
    }
  };

  handleSubmitModal = (visible) => {
    this.setState({
      modalSubmit: visible
    });
  };

  render() {
    const { formValues, updateCustomer } = this.props;
    const customStyles = {
      textAlign: 'center',
      top: '40%',
    }
    if (this.state.submit && this.state.modalSubmit === false) {
      window.location = config.baseUrl + "/shop/" + this.props.project.project_encrypt;
    }
    return (
      <main role="main" className="container_main">
        <div className="container">
          <RegisterHeader
            mode={this.state.mode}
            onEdit={this.handleEdit} />
          <RegisterForm
            mode={this.state.mode}
            onCustomerSubmit={() => updateCustomer(formValues)}
            onShowSubmitModal={this.showSubmitModal}
            openModel={this.openModal}
            closeModal={this.closeModal}
            disabled={this.checkMode()} />
          <RegisterModal show={this.state.modalOrder}
            onCancel={() => this.handleOrderModal(false, "View")}
            onOK={() => this.handleOrderModal(false, "Edit")}
            showCancel={true}
            title=""
            subTitle={msg.custCancelOrder}
            detail="" />
          <RegisterModal
            show={this.state.modalSubmit}
            onOK={() => this.handleSubmitModal(false)}
            title="" subTitle={this.state.message} detail="" />
          <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <ModalBody>
              <Spinner color="danger" />
              {'  ' + msg.register}
            </ModalBody>
          </Modal>
        </div>
      </main>
    );
  }
}

registerPage.propTypes = {
  fetchCustomer: PropTypes.func.isRequired,
  updateCustomer: PropTypes.func.isRequired,
  updateOrdersEditCustomer: PropTypes.func.isRequired,
  fetchTitles: PropTypes.func.isRequired,
  isFetching: PropTypes.bool
};

const mapStateToProps = state => ({
  formValues: state.form.register ? state.form.register.values : null,
  project: state.project.info,
  orders: state.orders.items,
  customer: state.customer.data,
  titles: state.titles,
  customerID: state.login ? state.login.customerID : "cus001",
  isFetching: state.customer.isFetching
});

export default connect(mapStateToProps, {
  fetchCustomer,
  updateCustomer,
  updateOrdersEditCustomer,
  fetchTitles,
  fetchAddressProject,
  fetchAddressCompany
})(registerPage);